import { jsPDF } from 'jspdf'
import html2canvas from 'html2canvas'

function nomeArquivoSeguro(nome) {
    const base = String(nome || 'resumo-projeto').replace(/[\\/:*?"<>|]+/g, '_').trim() || 'resumo-projeto'
    return base.toLowerCase().endsWith('.pdf') ? base : `${base}.pdf`
}

/**
 * Captura o DOM do resumo e gera PDF A4 paginado (mesmo fluxo do Base44).
 */
export async function gerarResumoPdf(elemento, nomeArquivo, titulo) {
    if (!elemento) {
        throw new Error('Elemento do resumo não encontrado')
    }

    // Expande containers roláveis para capturar todo o conteúdo
    const savedStyles = []
    elemento.querySelectorAll('*').forEach((el) => {
        const st = window.getComputedStyle(el)
        if (st.overflowY === 'auto' || st.overflowY === 'scroll' || st.overflowX === 'auto') {
            savedStyles.push({ el, maxHeight: el.style.maxHeight, overflow: el.style.overflow })
            el.style.maxHeight = 'none'
            el.style.overflow = 'visible'
        }
    })

    let canvas
    try {
        canvas = await html2canvas(elemento, {
            scale: 1.5,
            useCORS: true,
            backgroundColor: '#ffffff',
            logging: false,
            imageTimeout: 0,
            onclone(clonedDoc) {
                clonedDoc.documentElement.classList.remove('dark')
                clonedDoc.body?.classList.remove('dark')
                clonedDoc.querySelectorAll('.dark').forEach((el) => el.classList.remove('dark'))
            },
        })
    } finally {
        savedStyles.forEach(({ el, maxHeight, overflow }) => {
            el.style.maxHeight = maxHeight
            el.style.overflow = overflow
        })
    }

    const pdf = new jsPDF('p', 'mm', 'a4')
    const pageWidth = pdf.internal.pageSize.getWidth()
    const pageHeight = pdf.internal.pageSize.getHeight()
    const margin = 8
    const headerHeight = titulo ? 16 : 0
    const contentWidth = pageWidth - margin * 2
    const availableHeight = pageHeight - margin - headerHeight - margin

    const pxPerMm = canvas.width / contentWidth
    const pageHeightPx = availableHeight * pxPerMm
    let renderedHeight = 0
    let page = 0

    while (renderedHeight < canvas.height) {
        const sliceHeight = Math.min(pageHeightPx, canvas.height - renderedHeight)
        const pageCanvas = document.createElement('canvas')
        pageCanvas.width = canvas.width
        pageCanvas.height = sliceHeight
        const ctx = pageCanvas.getContext('2d')
        ctx.fillStyle = '#ffffff'
        ctx.fillRect(0, 0, pageCanvas.width, pageCanvas.height)
        ctx.drawImage(canvas, 0, renderedHeight, canvas.width, sliceHeight, 0, 0, canvas.width, sliceHeight)
        const pageImgData = pageCanvas.toDataURL('image/jpeg', 0.85)
        const sliceHeightMm = sliceHeight / pxPerMm

        if (page === 0 && titulo) {
            pdf.setFontSize(13)
            pdf.setTextColor(30, 41, 59)
            pdf.text(String(titulo), margin, margin + 5)
            pdf.setFontSize(8)
            pdf.setTextColor(100, 116, 139)
            pdf.text(`Gerado em ${new Date().toLocaleString('pt-BR')}`, margin, margin + 11)
            pdf.addImage(pageImgData, 'JPEG', margin, margin + headerHeight, contentWidth, sliceHeightMm)
        } else {
            pdf.addImage(pageImgData, 'JPEG', margin, margin, contentWidth, sliceHeightMm)
        }

        renderedHeight += sliceHeight
        if (renderedHeight < canvas.height) {
            pdf.addPage()
            page++
        }
    }

    pdf.save(nomeArquivoSeguro(nomeArquivo))
}

export { nomeArquivoSeguro }
